export const vulcan_pullover = {
  msrp: 54.99,
  infoLink: 'https://www.teamtriton.com/vulcan-pullover.html',
  items: [
    {
      number: 'VP099',
      hasModel: false,
    },
    {
      number: 'VP100',
      hasModel: false,
    },
    {
      number: 'VP101',
      hasModel: false,
    },
    {
      number: 'VP102',
      hasModel: false,
    },
    {
      number: 'VP103',
      hasModel: false,
    },
    {
      number: 'VP104',
      hasModel: false,
    },
    {
      number: 'VP105',
      hasModel: false,
    },
    {
      number: 'VP106',
      hasModel: false,
    },
    {
      number: 'VP107',
      hasModel: false,
    },
    {
      number: 'VP108',
      hasModel: false,
    },
    {
      number: 'VP109',
      hasModel: false,
    },
    {
      number: 'VP110',
      hasModel: false,
    },
  ],
};
